import type { ProviderKind, ServerProvider } from "@cmmd-forge/contracts";
import type { getAvailableProviderOptions } from "./ProviderModelPicker";

/**
 * Flattens the composer's model picker options into one search index: every
 * model across every visible provider (respecting a locked provider), each
 * carrying lowercased fields for the command-menu's search match.
 */
export function buildSearchableModelOptions(
  availableProviderOptions: ReturnType<typeof getAvailableProviderOptions>,
  lockedProvider: ProviderKind | null,
  modelOptionsByProvider: Record<ProviderKind, ReadonlyArray<ServerProvider["models"][number]>>,
) {
  return availableProviderOptions
    .filter((option) => lockedProvider === null || option.value === lockedProvider)
    .flatMap((option) =>
      modelOptionsByProvider[option.value].map(({ slug, name }) => ({
        provider: option.value,
        providerLabel: option.label,
        slug,
        name,
        searchSlug: slug.toLowerCase(),
        searchName: name.toLowerCase(),
        searchProvider: option.label.toLowerCase(),
      })),
    );
}
